/* --- STATE --- */

import { biStatus } from '../../../../locales/types';

export interface biDetailState {
  contractNumber: string;
  biDetail: biDetail | null;
  contractInfoView: ContractInfo | null;
  recurringView: RecurringData | null;
  oneOffView: OneOffData | null;
  depositView: DepositData | null;
  previewMode: boolean;
  displayData: biData | null;
  previousRecurring: any[];
  error?: ContractErrorType | null;
}

export interface biDetail {
  amendment: amendment[];
  view: biData;
}

export interface biData {
  contractInfo: ContractInfo;
  recurring: RecurringData;
  previousRecurring?: RecurringData;
  oneOff: OneOffData;
  deposit: DepositData;
  otherReimbursement?: ReimbursementData;
}

export interface PreviousRecurringTabItem {
  contractNo: string;
  detail: RecurringData;
  index: number;
}

export interface amendment {
  type: AmendmentType;
  data: WaiveData | TerminationData | ChangeBillDateData | biData;
  status: biStatus;
  biViewUpdate?: biData;
  relatedSections?: object;
  statusReasons?: object;
}

export interface ContractInfo {
  interestRate: number;
  submittedBy: string;
  contractType: string;
  GFA: number;
  submitDate: string;
  contractNumber: string;
  customerCode: string;
  businessNature: string;
  customerName: string;
  existingCustomer: boolean;
  renewedFromContract: string;
  renewedByContract: string;
  preAgreements?: string[];
  biRemark: string;
  signedDate: string;
  startDate: string;
  endDate: string;
  isRenewed: boolean;
  isNovated: boolean;
  terminationDate: string;
  actualMoveOutDate: string;
  contractTerm: number;
  contractCurrency: string;
  mrcIncrementPercentage: number;
  signingEntity: string;
  billingEntity: string;
  quoteNumber: string;
  isVoided?: boolean;
  bankGuarantee?: boolean;
}

export interface RecurringData {
  startDateTBC: boolean;
  billingCycle: string;
  paymentTerms: string;
  recurringItems: ContractItem[];
}

export interface ContractItem {
  location: string;
  startDate: string;
  endDate: string;
  terminationDate?: string;
  mrc?: number;
  nrc?: number;
  poNumber: string;
  description: string;
  products: Product[];
}

export interface Product {
  contractLineID: string;
  id: number;
  family: string;
  type: string;
  name: string;
  vas: string;
  accountCode: string;
  accountDesc: string;
  terminationDate: string;
  qty: number;
  unitPrice: number;
  mrc?: number;
  rentFreeMonth?: number;
  nrc?: number;
  percentage: number;
  floor: string;
  room: string;
  rack: string;
  kva: number;
}

export interface OneOffData {
  invoiceFurtherNotice: boolean;
  paymentTerms: string;
  oneOffItems: ContractItem[];
}

export interface DepositData {
  previousDeposit: number;
  currentDeposit: number;
  netDeposit: number;
  paymentTerms: string;
  poNumber: string;
}

export interface ReimbursementData {
  governmentRentRate: boolean;
  governmentRentRateRemark: string;
  electricityCharge: boolean;
  electricityChargeRemark: string;
  stampDuty: boolean;
  stampDutyRemark: string;
}

export interface WaiveData {
  totalWaiverAmount: number;
  totalWaiverDeposit: number;
  createionDate: string;
  products: WaiveContractLine[];
}

export interface WaiveContractLine {
  contractLineID: string;
  invoiceNumber: string;
  chargeType: string;
  contractCurrency: string;
  totalPrice: number;
  waiverAmount: number;
  waiverPeriodFrom: string;
  waiverPeriodTo: string;
}

export interface TerminationData {
  approvalDate: string;
  contractEndDate: string;
  termType: string;
  oldTermDate: string;
  newTermDate: string;
  totalCharge: number;
  accountMoveOut: string;
  contractMoveOut: string;
  outstandingPayment: number;
  products: TermContractLine[];
  recallInfo?: {
    reason_for_recall_id: string;
    reason_for_recall?: string;
    remark_for_recall?: string;
  };
  remarksToFinance?: string;
}

export interface TermContractLine {
  contractLineId: string;
  contractLineEndDate: string;
  oldTerminationDate: string;
  newterminationDate: string;
}

export interface ChangeBillDateData {
  status: AmendmentStatus;
  amendmentID: string;
  requestDate: string;
  oldContractStartDate: string;
  newContractStartDate: string;
  oldContractEndDate: string;
  newContractEndDate: string;
  createionDate: string;
  contractTerm: number;
  products: ChangeBillDateDataContractLine[];
}

export interface ChangeBillDateDataContractLine {
  contractLineId: string;
  oldContractLineStartDate: string;
  newContractLineStartDate: string;
  oldContractLineEndDate: string;
  newContractLineEndDate: string;
}

/* 
  If you want to use 'ContainerState' keyword everywhere in your feature folder, 
  instead of the 'HomePageState' keyword.
*/

// export type ContainerState = ContractDataState;

export enum AmendmentType {
  CHANGEBILLDATE = 'changeBillDate',
  WAIVER = 'waiver',
  TERMINATION = 'termination',
  BIUPDATE = 'biUpdate',
}

export enum AmendmentStatus {
  PENDING = 'Pending',
  COMPLETE = 'Complete',
  AUTOComplete = 'Auto',
}

export interface AmendmentDisplayValue {
  amendmentID: string;
  value: string;
  status: AmendmentStatus;
}

export type AmendmentValue = AmendmentDisplayValue;

export interface chatRecord {
  contractNumber: string;
  sortKey: string;
  type: string;
  user: string;
  createdAt: string;
  content: string;
  fileDatas: string[];
  senderEmail: string;
}

export enum ContractErrorType {
  NOT_FOUND = 'NOT_FOUND',
  SERVER_ERROR = 'SERVER_ERROR',
  NETWORK_ERROR = 'NETWORK_ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
}
